import * as React from 'react';
import LoggedUserNavToolsComponent from 'src/modules/commons/header/partials/LoggedUserNavTools.component';
import { connect, Dispatch } from 'react-redux';
import { LoginAction, logout } from 'src/actions/authentication/login/Login.actions';
import { RootState } from 'src/reducers/RootReducer';
import { openModal, OpenModal } from 'src/actions/modal';
import ChangeActiveProfileContainer
  from 'src/modules/modals/investment-funnel/change-profile/ChangeActiveProfile.container';
import Person from 'src/entities/Person';
import { GetUserAction, getUser } from 'src/actions/user/get/GetUser.actions';
import User from 'src/entities/User';

interface StateProps {
  activeProfile?: Person;
  user?: User;
  loggedUserData?: number | null;
}

interface DispatchProps {
  openModal(component: JSX.Element): void;
  logout(): LoginAction;
  getUser(userId: number): Promise<GetUserAction>;
}

interface Props extends DispatchProps, StateProps {
  handleBackButton?: () => void;
}

class LoggedUserNavToolsContainer extends React.Component<Props> {

  constructor(props: Props) {
    super(props);

    this.changeInvestorProfile = this.changeInvestorProfile.bind(this);
  }

  public componentWillMount(): void {
    if (this.props.loggedUserData && !this.props.activeProfile) {
      this.props.getUser(this.props.loggedUserData);
    }
  }
  public render(): React.ReactNode {
    return (
      <LoggedUserNavToolsComponent
        logout={this.props.logout}
        changeInvestorProfile={this.changeInvestorProfile}
        activeProfile={this.props.activeProfile}
        user={this.props.user}
      />
    );
  }

  private changeInvestorProfile(): void {
    this.props.openModal(<ChangeActiveProfileContainer />);
  }
}

const mapDispatchToProps = (dispatch: Dispatch<RootState>): DispatchProps => ({
  openModal: (component: JSX.Element): OpenModal => (dispatch(openModal(component))),
  logout: (): LoginAction => dispatch(logout()),
  getUser: (userId: number): Promise<GetUserAction> => dispatch(getUser(userId))
});

const mapStateToProps = (state: RootState): StateProps => ({
  activeProfile: state.getUser.activeProfile,
  loggedUserData: state.authentication.loggedUserData,
  user: state.getUser.user,
});

export default connect(mapStateToProps, mapDispatchToProps)(LoggedUserNavToolsContainer);



// WEBPACK FOOTER //
// ./src/modules/commons/header/partials/LoggedUserNavTools.container.tsx